import React, { useState, useEffect } from 'react';
import { Dialog, IconButton, Text } from '@oneaudi/unified-web-components';
import { useI18n } from '@oneaudi/i18n-context';
import { MonthlyRateContainer, PriceAndInfoIWrapper, PriceDivider, RateNextToInfoI, StyledPriceTextWrapper, } from './styles/FinanceRethink.styles';
import { FootnoteReference } from '../../../../components';
import { useServicesContext } from '../../../../context';
import { FinanceLayerRethink } from './FinanceLayerRethink';
import { trackLayerClose } from './FinanceTracking';
import { useFinance } from './FinanceContext';
import { dynamicStylingHelper, DynamicThemeProviderWrapper } from '../../../utils';
const RATE_SUFFIX_PLACEHOLDER = '{{PRODUCT}}';
export const RateInformationRethink = ({ isPLP, vehicle, vehicleBasic, staticRateConfig, }) => {
    var _a, _b, _c, _d;
    const trackingService = useServicesContext().getAdditionalService('audi-tracking-service');
    const rateInfoIAriaLabel = useI18n({
        id: 'stockcars.finance.rate.infoButton.arialabel',
        defaultMessage: '',
    });
    const [isDialogOpen, setIsDialogOpen] = useState();
    const vehicleBasicVal = isPLP ? vehicleBasic : vehicle.basic;
    if (!(vehicleBasicVal === null || vehicleBasicVal === void 0 ? void 0 : vehicleBasicVal.financing)) {
        return null;
    }
    const { financing } = vehicleBasicVal;
    const dynamicFinance = !isPLP
        ? (_a = useFinance()) === null || _a === void 0 ? void 0 : _a.dynamicFinance
        : {
            rate: staticRateConfig === null || staticRateConfig === void 0 ? void 0 : staticRateConfig.price,
            rateText: '',
            calculationDisclaimer: '',
        };
    const { rate: dRate, rateText } = dynamicFinance;
    const [rate, setRate] = useState(dRate || (staticRateConfig === null || staticRateConfig === void 0 ? void 0 : staticRateConfig.price));
    useEffect(() => {
        setRate(dRate || (staticRateConfig === null || staticRateConfig === void 0 ? void 0 : staticRateConfig.price));
    }, [dynamicFinance, staticRateConfig]);
    const staticRateSuffix = rateText
        ? (_b = staticRateConfig === null || staticRateConfig === void 0 ? void 0 : staticRateConfig.suffix) === null || _b === void 0 ? void 0 : _b.replace(RATE_SUFFIX_PLACEHOLDER, rateText)
        : (_c = staticRateConfig === null || staticRateConfig === void 0 ? void 0 : staticRateConfig.suffix) === null || _c === void 0 ? void 0 : _c.replace(RATE_SUFFIX_PLACEHOLDER, (_d = financing === null || financing === void 0 ? void 0 : financing.product) === null || _d === void 0 ? void 0 : _d.label);
    if (!rate)
        return null;
    return (React.createElement(React.Fragment, null,
        React.createElement(PriceDivider, null),
        React.createElement(MonthlyRateContainer, null,
            React.createElement(PriceAndInfoIWrapper, null,
                React.createElement(RateNextToInfoI, null,
                    React.createElement(Text, { tag: "p", variant: { type: 'copy', order: dynamicStylingHelper('2', '3'), style: 'normal' } }, staticRateConfig === null || staticRateConfig === void 0 ? void 0 : staticRateConfig.label),
                    React.createElement(StyledPriceTextWrapper, null,
                        React.createElement(Text, { className: "apply-alpha-style", tag: "p", variant: { type: 'copy', order: '1', style: 'normal' } },
                            rate,
                            (staticRateConfig === null || staticRateConfig === void 0 ? void 0 : staticRateConfig.priceFootnote) && (React.createElement(FootnoteReference, { refId: staticRateConfig === null || staticRateConfig === void 0 ? void 0 : staticRateConfig.priceFootnote }))),
                        React.createElement(Dialog, { "aria-label": "This is an Dialog of type Focus Small", onCloseButtonAriaLabel: "Close", hasCloseButton: true, triggerButton: React.createElement(IconButton, { variant: "tertiary", size: dynamicStylingHelper('md', 'xs'), onClick: () => {
                                    setIsDialogOpen(true);
                                }, icon: "info-circle", id: "info-button-price", "aria-label": rateInfoIAriaLabel }), variant: "focus-large", open: isDialogOpen, onClose: () => {
                                setIsDialogOpen(false);
                                trackLayerClose(trackingService, 'vtp leasing layer');
                            } },
                            React.createElement(DynamicThemeProviderWrapper, null,
                                React.createElement(FinanceLayerRethink, { isPlp: isPLP, vehicleBasic: vehicleBasicVal, isOpen: isDialogOpen })))),
                    React.createElement(Text, { tag: "p", variant: { type: 'copy', order: '3', style: 'normal' } }, staticRateSuffix))))));
};
